module.exports = __webpack_public_path__ + "img/last_world.d2160da5.jpg";